import {Component, Inject, Input} from 'ng-metadata/core';
import {JwtUtilService} from "../../../../../security/jwtUtil.service";
import { getResourceType } from '../../../../../infra/ngrsUtil';

@Component({
    "selector": "prm-offer-details-tile",
    templateUrl: 'components/search/fullView/ngrs/getItRequest/offerDetailsTile/offerDetailsTile.html'
})

export class PrmOfferDetailsTile{

    @Input() bestoffer:Object;
    @Input() private isdigitaloffer: boolean;
    @Input() item:Object;

    constructor (){
    }

    ngOnInit(){
    }

    public getOfferLoanPeriod(){
        return this.bestoffer? this.bestoffer.loanPeriod : undefined;
    }
    
    public getOfferSupplyTime(){
        return this.bestoffer? this.bestoffer.supplyTime : undefined;
    }
    
    public isUnavailableResource(){
        return this.bestoffer? this.bestoffer.unavailableResource : undefined;
    }
    
    public isDigitalOffer(){
        return this.isdigitaloffer;
    }

    public isNoOfferAfterRefine(){
        return this.bestoffer? this.bestoffer._noOfferAfterRefine : undefined;
    }
    
    public getNoOfferAfterRefineMessage(){
        if (this.bestoffer && this.bestoffer._showPUANoOfferMessage){
            return "nui.ngrs.pickup.information.failedToFindOfferWithPickupInstitution";
        }
        return "rapido.tiles.physical.no_best_offer.line_3"
    }

    public getResourceType(){
        return getResourceType(this.item);
    }

    public getPatronCost(){
        return this.bestoffer? this.bestoffer.patronCost : undefined;
    }

    public getCurrency(){
        return this.bestoffer? this.bestoffer.currency : undefined;
    }

    public isShowPatronCost(){
        return this.bestoffer? this.bestoffer.hasOwnProperty('patronCost')
            && typeof this.bestoffer.patronCost != "undefined" && typeof this.bestoffer.currency != "undefined" : undefined;
    }

    public isEbookOffer(){
        if (!this.bestoffer == null || !this.bestoffer.ebookOffer){
            return false;
        }
        return this.bestoffer.ebookOffer;
    }

}








// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/getItRequest/offerDetailsTile/offerDetailsTile.directive.ts